export const OFFERS_TO_DISPLAY = 'offers-to-display';
export const ORDER_ERROR_MESSAGE = 'order-error-message';
export const PAYMENT_METHODS = 'payment-methods';
export const PAYMENT_INFORMATION = 'payment-information';
export const FORGOT_PASSWORD = 'forgot-password';
export const RESET_PASSWORD = 'reset-password';
export const AUTOMATIC_OFFERS = 'automatic-offers';
export const THRESHOLD_MESSAGES = 'threshold-messages';
export const MANUAL_OFFER = 'manual-offer';
export const ORDER_CONFIRMATION_COMPONENT = 'order-confirmation-component';
export const PASSWORD_STRENGTH = 'password-strength';
export const SAVE_FOR_LATER_LIST = 'save-for-later-list';
export const SIGN_IN_FORM = 'sign-in-form';

export const SIGN_UP_FORM = 'sign-up-form';
export const CHANGE_PASSWORD = 'change-password';
export const CHANGE_EMAIL = 'change-email';
export const EMAIL_VERIFICATION = 'email-verification';
export const CONFIRM_REGISTRATION = 'confirm-registration';

export const ADDRESS_FORM = 'address-form';
export const ADDRESS_LIST = 'address-list';
export const FORMATTED_ADDRESS = 'formatted-address';
export const RETURN_USER_EMAIL = 'return-user-email';
export const USER_PROFILE = 'user-profile';
export const USER_EMAIL = 'user-email';
export const USER_EMAIL_WITH_OPT_IN = 'user-email-with-opt-in';
export const SIGN_OUT_LINK = 'sign-out-link';
export const CART_ITEMS = 'cart-items';
export const CART_ORDER_SUMMARY = 'cart-order-summary';
export const CART_MERGE = 'cart-merge';
export const ACCOUNT_INFO = 'account-info';
export const PRODUCT_GRID = 'product-grid';
export const PRODUCT_FULL = 'product-full';
export const PRODUCT_FULL_ORDERABLE = 'product-full-orderable';
export const CART_OVERLAY = 'cart-overlay';
export const CART_ICON_BUTTON = 'cart-icon-button';
export const ACCOUNT_OVERLAY = 'account-overlay';
export const ORDER_HISTORY = 'order-history';
export const ORDER_DETAILS = 'order-details';
export const ORDER_HISTORY_COUNTER_BUTTONS = 'order-history-counter-buttons';
export const ORDER_HISTORY_TEMPORARY_MODULE = 'order-history-temporary-module';
export const ACCOUNT_INFO_LINK = 'account-info-link';
export const SIGN_IN_NAV_LINK = 'sign-in-nav-link';

export const EMAIL_OPT_IN = 'email-opt-in';
export const VIEW_EMAIL_OPT_IN = 'view-email-opt-in';
export const HELPFUL_LINKS = 'helpful-links';

export const ACCOUNT_LANDING_SCREEN = 'account-landing-screen';
export const SIGN_UP_SCREEN = 'sign-up-screen';
export const SIGN_IN_SCREEN = 'sign-in-screen';
export const ORDER_CONFIRMATION_SCREEN = 'order-confirmation-screen';
export const ORDER_ASSOCIATION_SCREEN = 'order-association-screen';
export const EXTERNAL_PAYMENT_ERROR_SCREEN = 'external-payment-error-screen';
export const PAYMENT_SCREEN = 'payment-screen';
export const PAYMENT_NAME = 'payment-name';
export const PAYMENT_ICON = 'payment-icon';
export const CHECKOUT_HEADER = 'checkout-header';
export const CHECKOUT_FOOTER = 'checkout-footer';
export const SHIPPING_SCREEN = 'shipping-screen';
export const SHOPPING_BAG_PAGE = 'shopping-bag-page';
export const PRODUCT_BRIEF = 'product-brief';
export const PRODUCT_QUICKVIEW = 'product-quickview';
export const SHIPPING_METHODS = 'shipping-methods';
export const ELC_CHECKOUT = 'elc-checkout';
export const ELC_ACCOUNT = 'elc-account';
export const STYLEGUIDE = 'style-guide';
export const PRODUCT_NOTIFY_ME = 'product-notify-me';
export const CHOICE_OF_SKUS_LIST = 'choice-of-skus-list';
export const PRODUCT_CROSS_SELL = 'product-cross-sell';
export const PRODUCT_ADD_TO_BAG = 'product-add-to-bag';
export const PRODUCT_SHADESVIEW = 'product-shadesview';
export const PRODUCT_SIZE_PICKER = 'product-size-picker';
export const PRODUCT_QUANTITY_SELECTOR = 'product-quantity-selector';
export const PRODUCT_SHADE_PICKER = 'product-shade-picker';
export const PRODUCT_MEDIA_CAROUSEL_NAV = 'product-media-carousel-nav';
export const PRODUCT_SHADE_PICKER_BUTTON = 'product-shade-picker-button';
export const PRODUCT_RATING = 'product-rating';
export const PRODUCT_RATING_WRAPPER = 'product-rating-wrapper';
export const PRODUCT_REVIEWS = 'product-reviews';
export const PRODUCT_CTA = 'product-cta';
export const PRODUCT_SHADES_SIDEBAR = 'product-shades-sidebar';
export const PRODUCT_BASIC_INFO = 'product-basic-info';
export const PRODUCT_BASIC_CTA = 'product-basic-cta';

export const CONTENT_BLOCK = 'content-block';
export const BASIC_TOUT = 'elc-basic-tout-v1';
export const VIDEO_TOUT_YOUTUBE = 'elc-video-tout-youtube-v1';
export const VTO_FOUNDATION_OVERLAY = 'elc-vto-foundation-overlay-v1';

export const OLAPIC_WIDGET = 'ugc-olapic-widget';

export const VTO = 'vto';
export const VTO_SKIN_CARE = 'vto-skin-care';

export const STORES = 'stores';
export const STORES_DIRECTORY = 'stores-directory';
export const SEARCH_RESULTS = 'search-results';
export const SEARCH_GNAV_INPUT_FIELD = 'search-gnav-input-field';
export const VOICE_SEARCH = 'voice-search';
export const STORE_DETAILS = 'store-details';
export const FIND_IN_STORE_BUTTON = 'find-in-store-button';
export const FIND_IN_STORE_MODAL = 'find-in-store-modal';
export const PICK_UP_IN_STORE = 'pick-up-in-store';

export const STYLEGUIDE_TYPOGRAPHY = 'styleguide-typography';
export const STYLEGUIDE_BUTTONS = 'styleguide-buttons';
export const STYLEGUIDE_INPUTS = 'styleguide-inputs';
export const STYLEGUIDE_COMPONENTS = 'styleguide-components';
